module.exports = __webpack_public_path__ + "img/a.a1e0fc96.png";